import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-datepicker', 'chooseDate', 'Выберите дату');
Labels.set('ui-datepicker', 'selectedDate', 'Выбранная дата');
Labels.set('ui-datepicker', 'close', 'Закрыть');
Labels.set('ui-datepicker', 'clear', 'Очистить поле');
